export default __webpack_public_path__ + "static/media/dancer1.7c862706.gif";